var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"value":_vm.status,"right":true,"bottom":true,"timeout":-1,"vertical":true}},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('v-btn',{attrs:{"color":"pink","text":""},on:{"click":_vm.clear}},[_vm._v(" 閉じる ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }